<app-header
  (navigationClick)="onNavigationClick($event)"
  [lotteryEnded]="lotteryEnded()"
/>

<main class="app-con" style="overflow: hidden">
  @if (lotteryEnded()) {
    <app-end-top-section (navigationClick)="onNavigationClick($event)" />
  } @else {
    <app-top-section
      #topSection
      (navigationClick)="onNavigationClick($event)"
    />
  }
  <app-rewards-section #rewardsSection />
  @if (!lotteryEnded()) {
    <app-what-todo-section
      #whatTodoSection
      (navigationClick)="onNavigationClick($event)"
    />
    <app-counter-section [targetDate]="endDate" />
    <app-form-section #formSection (register)="onRegister($event)" />
  }
  <app-blik-section #blikSection />
  <app-video-section #videoSection />
  <app-products-section #productsSection />

  <section #winnersSection>
    @defer (on viewport; prefetch on idle) {
      <app-winners-section />
    } @placeholder (minimum 500ms) {
      <div class="container">
        <ngx-skeleton-loader
          [animation]="'progress'"
          [appearance]="'line'"
          [count]="12"
        />
      </div>
    } @loading (after 500ms; minimum 1s) {
      <div class="container">
        <ngx-skeleton-loader
          [animation]="'progress'"
          [appearance]="'line'"
          [count]="12"
        />
      </div>
    }
  </section>
  <app-follow-section #followSection />
  <app-faq-section #faqSection />
</main>

<app-scroll-to-top />
<app-footer />
